import useTitanApp from "../../../hooks/useTitanApp";
import {
  setPrevConsultationsDetailData,
  setShowPreviousConsultationsModal,
} from "../../../dispatchers/patientDispatchers";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { FiCalendar, FiUser } from "react-icons/fi";

export default function PatientPreviousConsultationsModal() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const { showPreviousConsultationsModal, prevConsultationsDetailData } =
    patientState || {};

  const { createdOn, createdByName, summary, actionsData } =
    prevConsultationsDetailData || {};
  // const parsed = JSON.parse(transcription);
  // delete parsed?.Actions;
  // const summaryText = Object.entries(parsed)
    // .map(([key, value]) => `${key}: ${value}`)
    // .join("\n\n");
      const formatSummaryText = (text) => {
    if (!text) return text;
    let formattedText = text
      .replace(/\\n/g, "\n")
      .replace(/([a-zA-Z ]+:)\s*/g, "$1\n")
      .replace(/\n{3,}/g, "\n\n")
      .replace(/"/g, "")
      .trim();
    return formattedText;
  };
  const closeModal = () => {
    setShowPreviousConsultationsModal(false);
    setPrevConsultationsDetailData(null);
  };

  const getPayloadData = (ActionNumber, ActionPayload) => {
    const number = Number(ActionNumber);

    try {
      switch (number) {
        case 1: {
          // Prescription
          const payloadString = ActionPayload?.Payload;
          if (!payloadString) return "No prescription details";

          const parsed = JSON.parse(payloadString);
          const prescription = parsed?.prescriptionsDetails?.[0]?.value;
          return prescription
            ? `Prescription Created: ${prescription}`
            : "No prescription details";
        }

        case 2: {
          // Payment
          return ActionPayload?.Payload
            ? JSON.parse(ActionPayload.Payload)
            : "No payment data available";
        }

        case 3: {
          // Referral
          const payloadString = ActionPayload?.Payload;
          if (!payloadString) return "No referral data";
          const parsed = JSON.parse(payloadString);
          return parsed?.letterContent?.title || "Referral details missing";
        }

        case 4: {
          // Booking
          try {
            const parsed = ActionPayload?.Payload
              ? JSON.parse(ActionPayload.Payload)
              : ActionPayload;

            const formData = parsed?.bookingForms?.[0]?.formData;

            return {
              appointmentName: formData?.appointmentName || "",
              appointmentDate: formData?.appointmentDate || "",
            };
          } catch (error) {
            console.error("Failed to parse booking payload:", error);
            return {
              appointmentName: "",
              appointmentDate: "",
            };
          }
        }

        case 5: {
          // Vitals
          const vitals = ActionPayload?.vitalsDetails;
          if (!vitals) return "No vitals recorded";

          const details = [];

          if (vitals.HeartRate?.Value) {
            details.push(
              `Heart Rate: ${vitals.HeartRate.Value} ${
                vitals.HeartRate.Unit || ""
              }`
            );
          }

          if (vitals.Weight?.Value) {
            details.push(
              `Weight: ${vitals.Weight.Value} ${vitals.Weight.Unit || ""}`
            );
          }

          if (vitals.Temperature?.Value) {
            details.push(
              `Temp: ${vitals.Temperature.Value} ${
                vitals.Temperature.Unit || ""
              }`
            );
          }

          if (
            vitals.BloodPressure?.systolic?.Value &&
            vitals.BloodPressure?.diastolic?.Value
          ) {
            details.push(
              `BP: ${vitals.BloodPressure.systolic.Value}/${
                vitals.BloodPressure.diastolic.Value
              } ${vitals.BloodPressure.systolic.Unit || ""}`
            );
          }

          return details.length > 0 ? details.join(", ") : "No vitals recorded";
        }

        case 6: {
          // Vaccination
          return (
            ActionPayload?.vaccinationDetails?.[0]?.value ||
            "No vaccination info"
          );
        }

        default:
          return "Unknown action";
      }
    } catch (error) {
      console.error("Error processing action payload:", error);
      return "Invalid data format";
    }
  };

  const properData = Array.isArray(actionsData)
    ? actionsData.map((action) =>
        getPayloadData(action.actionNumber, action.payload)
      )
    : [];

  const formatPayload = (data) => {
    if (!data) return "No details";
    return data;
  };

  const isValidDate = (date) => date instanceof Date && !isNaN(date);

  return (
    <Modal
      show={showPreviousConsultationsModal}
      onHide={closeModal}
      centered
      backdrop="static"
      dialogClassName="addNewModal pc-add-vitals-modal prev-consult-modal"
      size="lg"
    >
      <div className="header">
        <div className="info">
          <FiCalendar color={darkMode ? "#fff" : "#0a0a0a"} />
          <p className="label">Consultation Details</p>
        </div>
        <IoClose
          size={20}
          color={darkMode ? "#bdbdbd" : "#0a0a0a"}
          onClick={closeModal}
        />
      </div>

      <div className="body" id="bodyID">
        <div className="upper">
          <div className="details">
            <p className="date">
              {isValidDate(createdOn)
                ? createdOn.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : ""}
            </p>
            <p className="time">
              {isValidDate(createdOn)
                ? createdOn
                    .toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })
                    .toLowerCase()
                : ""}
            </p>
            <div className="dr">
              <FiUser color="#999" size={14} />
              <p>{createdByName ?? "-"}</p>
            </div>
          </div>
          {summary && (
            <div className="description">
              <p>{formatSummaryText(summary)}</p>
            </div>
          )}
        </div>

        {Array.isArray(actionsData) && actionsData.length > 0 && (
          <div className="lower">
            <p className="heading">Actions Taken</p>
            <div className="action-tags-wrapper">
              {actionsData.map((action, idx) => {
                const data = properData[idx];
                return (
                  <div className="action-tag" key={idx}>
                    <div
                      style={{ backgroundColor: action.bgColor }}
                      className="icon"
                    >
                      {action.icon}
                    </div>
                    <p className="action-text">
                      {action.actionNumber === 4 && data ? (
                        <>
                          {action.title}:{" "}
                          <span>
                            {data.appointmentName}
                            <br />
                            {data.appointmentDate
                              ? new Date(
                                  data.appointmentDate
                                ).toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                              : ""}
                          </span>
                        </>
                      ) : (
                        <>
                          {action.title}: <span>{formatPayload(data)}</span>
                        </>
                      )}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      <div className="footer">
        <button onClick={closeModal}>Close</button>
      </div>
    </Modal>
  );
}
